<template>
   <div class="news">
       <!-- <div class="img-ss">
            <img class="gens-img" src="../assets/images/headerimg/Header_1920x380_news.jpg" />
             <h1 class="gens-title">{{$t('ContractText.newinfo')}}</h1>
       </div> -->
        <banner>
            <img src="../assets/images/headerimg/Header_1920x380_news.jpg"/>
            <div slot="title">{{$t('ContractText.newinfo')}}</div>
        </banner>
       <div class="new_category">
           <div class="new_category_item" @click="category='-1'" :class="category=='-1'?'active':''">
               <span v-if="$i18n.locale!='en-US'">全部</span>
               <span v-if="$i18n.locale=='en-US'">ALL</span>
               </div>
           <div class="new_category_item" @click="category='0'" :class="category=='0'?'active':''">{{$t('news.holiday')}}</div>
           <div class="new_category_item" @click="category='1'" :class="category=='1'?'active':''">{{$t('news.specialNotice')}}</div>
       </div>
       <div class="new_info_history">
            <div class="new_info_history_item" v-for="(item,index) in newsData" :key="item.Id" v-if="index<4&&(item.New_Category==category||category==-1)">
               <div class="item_img">
                   <img :src="item.PdfImgUrl" class="item_img_img"/>
                   <div class="item_img_icon" @click="OpenPdf(item.PdfUrl)">
                       <div class="item_img_icon_div" >
                           <div class="recyle" @click="openImg(item.PdfImgUrl)">+</div>
                       </div>
                   </div>
               </div>
               <div class="item_content_tip">
                   <div class="tip_text" @click="OpenPdf(item.PdfUrl)">{{item.New_tip}}</div>
                   <div  class="line"></div>
                   <div class="holiday">
                       <span v-if="item.New_Category==0">假期安排</span>
                       <span v-if="item.New_Category==1">特別通知</span>
                       </div>
               </div>
            </div>
            <div class="new_info_history_item" v-for="(item,index) in newsData" :key="item.Id" v-if="index>=4&&showMore&&(item.New_Category==category||category==-1)">
               <div class="item_img">
                   <img :src="item.PdfImgUrl" class="item_img_img"/>
                   <div class="item_img_icon" @click="OpenPdf(item.PdfUrl)">
                       <div class="item_img_icon_div" >
                           <div class="recyle" @click="openImg(item.PdfImgUrl)">+</div>
                       </div>
                   </div>
               </div>
               <div class="item_content_tip">
                   <div class="tip_text" @click="OpenPdf(item.PdfUrl)">{{item.New_tip}}</div>
                   <div  class="line"></div>
                   <div class="holiday">
                       <span v-if="item.New_Category==0">假期安排</span>
                       <span v-if="item.New_Category==1">特別通知</span>
                       </div>
               </div>
            </div>
       </div>

       <div class="more_new" v-if="!showMore">
           <button class="more_new_btn" @click="showMore=true">
               
               <span v-if="$i18n.locale!='en-US'">了解更多</span>
               <span v-if="$i18n.locale=='en-US'">Show More</span>
            </button>
       </div>
       <el-dialog title="" :visible.sync="dialogImgVisible" width="594px" :show-close='false'>
            <el-carousel height="769px" :autoplay='false'   @change="changeImg">
                <el-carousel-item >
                   <img id="fullResImage" :src="pathImg" style="height: 769px; width: 594px;">
                </el-carousel-item>
                <el-carousel-item v-for="item in newsData" :key="item.Id" v-if="item.PdfImgUrl!=pathImg">
                   <img id="fullResImage" :src="item.PdfImgUrl" style="height: 769px; width: 594px;" >
                </el-carousel-item>
            </el-carousel>
       </el-dialog>
   </div>
</template>
<script>
import {GetPagNewsAll} from '@/service/searchreport'
import banner from '@/components/banner'
export default {
    data(){
        return{
            showMore:false,
            dialogImgVisible:false,
            pathImg:'',
            newsData:[],
            category:'-1',
        }
    },
    components: {
      banner,
     
    },
    mounted(){
        this.GetPagNewsAll();
    },
    methods:{
        OpenPdf(path){
            window.open(path,'_blank')
        },
        changeImg(index){
            console.log('是大势所趋 ',index);
        },
        openImg(path){
            this.dialogImgVisible=true;
            this.pathImg=path;
        },
        lastImg(){
            let that=this
             console.log("last",that.pathImg)
            if(that.pathImg!=""){
                let i=0;
                that.newsData.map((val)=>{
                    if(i=0){
                      that.pathImg=val.PdfImgUrl;
                    }
                    if(that.pathImg==val.PdfImgUrl){
                        i++;
                    }
                })
                
            }
        },
        nextImg(){
            let that=this;
            console.log('next',that.pathImg)
            if(that.pathImg!=""){
                let i=0;
                that.newsData.map((val)=>{
                    if(i>0){
                        that.pathImg=val.PdfImgUrl;
                        i=-1;
                    }
                    if(that.pathImg==val.PdfImgUrl&&i!=-1){
                        i++;
                    }
                })
            }
        },
        async GetPagNewsAll(){
            let resp=await GetPagNewsAll();
            if(resp){
                if(resp.length>0){
                    resp.map((val)=>{
                        val.PdfUrl=process.env.BASE_URL+val.PdfUrl;
                        val.PdfImgUrl=process.env.BASE_URL+val.PdfImgUrl;
                    })
                }
                 this.newsData=[];
                 this.newsData=resp;
            }
           
        }
    }
}
</script>

<style lang="scss" scoped>
.news{
      width: 100%;
    
    margin-top:1rem;
    text-align: center;
    .img-ss{
        position: relative;
        .gens-img{
            max-width: 100%;
            height: auto;
            position: relative;
        }
         .gens-title{
                    width: 100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: bold;
                    top:0;
            }
    }
    .new_category{
        margin-top:40px;
        margin-bottom:60px;
        display: flex;
        justify-content: center;
        align-items: center;
        width:100%;
        flex-direction:row;
        .new_category_item{
            margin-right:70px;
            color: #51cedd;
            font-weight: 600;
            font-size:16px;
        }
        .new_category_item:hover{
            color: #1abc9c!important;
        }
        .active{
            color: #368da7 !important;
        }
    }
    .new_info_history{
        padding:25px 25px 25px -10px !important;
        display: flex;
        justify-content:space-between;
        flex-wrap: wrap;
        align-items: flex-start;
        width:1200px;
        
        margin:auto;
        .new_info_history_item{
            cursor: pointer;
            background-color: #f4fcff;
            // padding-bottom:15px;
            margin-bottom:25px;
            flex-basis:300px;
            width:300px;
            display: block;
            .item_img{
                    position: relative;
                    display: flex;
                    justify-content: center;
                    overflow: hidden;
                    width: 100%;
                   
            }
            .item_img_img{
                position: relative;
                display: block;
                width: 308px;
                z-index: 100;
                height: 382px;
                z-index: 1;
                transition: all 1s ease 0s;
              
            }
            .item_img .item_img_icon{
                display: none;
                height: 100%;
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 200;
                opacity: 0;
                filter: alpha(opacity=0);
                /* transition 属性是一个简写属性，用于设置四个过渡属性： */
                /* transition: property duration timing-function delay; */
                /* transition-property  规定设置过渡效果的 CSS 属性的名称。 */
                /* transition-duration  规定完成过渡效果需要多少秒或毫秒。 */
                /* transition-timing-function   规定速度效果的速度曲线。 */
                /* transition-delay 定义过渡效果何时开始。 */
                /* transition-delay: 0s;
                transition-duration: 0.3s;
                transition-property: opacity;
                transition-timing-function: ease-in; */
                transition: opacity 0.3s ease-in 0s;
            }
            .item_img:hover img{
                transform: scale(1.4, 1.4);
            }
            .item_img:hover .item_img_icon {
                background-color: rgba(30,30,30,0.3) !important;
                opacity: 1;
                filter: alpha(opacity=100) !important;
                 display: block;
            }
            .item_img_icon_div{
                width:100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .recyle{
                width:50px;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 100%;
                font-size:24px;
                font-weight: 800;
                color:#fff;
                background-color: #368da7;
            }

            .item_content_tip{
                border-color: #fefefe;
                background-color:#fff;
                padding-bottom:20px;
                .tip_text{
                    color: #368da7;
                     font-size: 16px;
                     font-size: 20px;
                    line-height: 30px;
                    font-style: normal;
                    font-weight: 300;
                    letter-spacing: 0;
                    text-transform: none;
                    display: block;
                    text-align: center;
                    margin: 0 0 7px;
                    padding-left: 25px;
                    padding-right: 25px;
                    padding: 20px 0 0 22px;
                    width: 100%;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
                .line{
                    background-color: #51cedd;
                    margin-top: 10px;
                    margin-bottom: 10px;
                    height: 2px;
                    position: relative;
                    width: 22px;
                    display: block;
                    margin: 10px auto 20px;
                    text-align: center;
                }
                .holiday{
                    color: #797e81;
                    font-size: 12px;
                    line-height: 12px;
                    font-style: normal;
                    font-weight: 300;
                    letter-spacing: 0;
                    text-transform: none;
                }
            }
        }
    }
    .more_new{
        width:100%;
        text-align: center;
        margin: 15px 0 ;
        .more_new_btn{
                color: #368da7;
                font-size: 14px;
                height: 36px;
                font-style: normal;
                font-weight: 400;
                border-radius: 5px;
                -moz-border-radius: 5px;
                -webkit-border-radius: 5px;
                letter-spacing: 0;
                text-transform: none;
                border-width: 2px;
                position: relative;
                border-color: #368da7;
                background-color:#fff;
                box-shadow: none;
                border-style: double;
                

        }
        .more_new_btn:hover{
            background-color: #368da7 !important;
            border-color: #368da7 !important;
            color: #fff !important;
            text-decoration: none !important;
        }
    }
}
</style>

<style>
.el-carousel__arrow:hover{
    background-color: #9bd9dd !important;
}

.el-dialog__header{
    padding:0 0;
}


</style>


// WEBPACK FOOTER //
// src/view/news.vue